import { useQuery } from "@tanstack/react-query";
import { mapSelectOptions } from "../../utils/map4select";
import { trackAndTraceKeys } from "./trackAndTrace.keys";
import { trackAndTraceService } from "./trackAndTrace.service";
import {
  IzvestajiOPrometuPayload,
  MonitoringDetailsResponse,
  MonitoringListFilterPayload,
  MonitoringListResponse,
  TrackingListFilterPayload,
  TrackingListFiltersDataResponse,
  TrackingListResponse,
} from "./trackAndTrace.types";

export function useMonitoringList({
  enabled,
  filters,
}: {
  enabled?: boolean;
  filters?: Partial<MonitoringListFilterPayload> | undefined;
}) {
  return useQuery({
    ...trackAndTraceKeys.monitoringList({
      filters,
    }),
    queryFn: () => trackAndTraceService.getMonitoringList(filters),
    select: (response) =>
      ({
        list: response?.data?.list ?? [],
        total: response?.data?.total ?? 0,
      } as MonitoringListResponse),
    retry: false,
    enabled,
  });
}

export function useMonitoringDetails({
  enabled,
  id,
}: {
  enabled?: boolean;
  id: number | null;
}) {
  return useQuery({
    ...trackAndTraceKeys.monitoringDetails({ id }),
    queryFn: () => trackAndTraceService.getMonitoringDetails({ id }),
    select: (response): MonitoringDetailsResponse => response?.data,
    retry: false,
    enabled,
  });
}

export function useTrackingList({
  enabled,
  filters,
}: {
  enabled?: boolean;
  filters?: Partial<TrackingListFilterPayload> | undefined;
}) {
  return useQuery({
    ...trackAndTraceKeys.trackingList({
      filters,
    }),
    queryFn: () => trackAndTraceService.getTrackingList(filters),
    select: (response) =>
      ({
        list: response?.data?.list ?? [],
        total: response?.data?.total ?? 0,
      } as TrackingListResponse),
    retry: false,
    enabled,
  });
}

export function useTrackingListFiltersData() {
  return useQuery({
    ...trackAndTraceKeys.trackingListFiltersData(),
    queryFn: () => trackAndTraceService.getTrackingListFiltersData(),
    select: (response) =>
      ({
        statuses: mapSelectOptions({
          sourceArray: response?.data?.status,
          labelAccessor: "naziv",
          valueAccessor: "id",
        }),
        packageTypes: mapSelectOptions({
          sourceArray: response?.data?.tipPakovanja,
          labelAccessor: "naziv",
          valueAccessor: "id",
        }),
      } as TrackingListFiltersDataResponse),
    retry: false,
  });
}

export function useIzvestajiOPrometu({
  enabled,
  filters,
}: {
  enabled?: boolean;
  filters?: IzvestajiOPrometuPayload | undefined;
}) {
  return useQuery({
    ...trackAndTraceKeys.izvestajiOPrometu({ filters }),
    queryFn: () => trackAndTraceService.getIzvestajiOPrometu(filters),
    select: (response) => response?.data,
    retry: false,
    enabled,
  });
}
